// import Router from './router';
// import Navigation from './components/Navigation';
// import Footer from './components/Footer';

// export default function App() {
//   return (
//     <div className="min-h-screen flex flex-col">
//       <Navigation />
//       <main className="flex-grow">
//         <Router />
//       </main>
//       <Footer />
//     </div>
//   );
// }

// export default function App() {
//   return (
//     <div className="bg-black text-white p-8">
//       <h1 className="text-3xl font-bold text-green-400">✅ App is Rendering</h1>
//       <p className="mt-4">If you see this, your root setup is working.</p>
//     </div>
//   );
// }

import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Home from "./pages/Home";
import Navigation from "./components/Navigation";
import About from "./pages/About";
import ServicesPage from "./pages/Services";
import IndustriesPage from "./pages/Industries";
import CaseStudiesPage from "./pages/CaseStudies";
import CareersPage from "./pages/Careers";
import ResourcesPage from "./pages/Resources";
import ContactPage from "./pages/Contact";
import { Helmet } from "react-helmet-async";
import Footer from "./components/Footer"; // ← make sure this exists
import ImageVideoCollection from "./components/ImageVideoCollection";
import AudioCollection from "./components/AudioCollection";
import TextDataSourcing from "./components/TextDataSourcing";
import AnnotationLabeling from "./components/AnnotationLabeling";
import AudioVideoTagging from "./components/AudioVideoTagging";
import TextSpeechQA from "./components/TextSpeechQA";
import MultilingualTranscription from "./components/MultilingualTranscription";
import TranslationLocalization from "./components/TranslationLocalization";
import DubbingVoiceover from "./components/DubbingVoiceover";
import VideoEditing from "./components/VideoEditing";
import AnimationProject from "./components/AnimationProject";
import ContentCreation from "./components/ContentCreation";
import VideoProject from "./components/VideoProject";
import IndustriesTechnologyAI from "./components/IndustriesTechnologyAI";
import ECommerceRetail from "./components/ECommerceRetail";
import HealthcareAI from "./components/HealthcareAI";
import AutomotiveAI from "./components/AutomotiveAI";
import MediaEntertainment from "./components/MediaEntertainment";
import ServicesAndIndustries from "./components/ServicesAndIndustries";
import ScrollManager from "./components/ScrollManager";
import {ScrollRestoration }from './components/ScrollRestoration';
import ScrollToTop from "./components/Scrolltop";
import Scrolltop from "./components/Scrolltop"
import Single1 from "./components/Single1";
import Admin from "./components/Admin";
import Dashboard from "./components/Dashboard";
import ProjectList from "./components/ProjectList";
import { ProjectProvider } from "./components/ProjectContext";


export default function AppRouter() {
  return (
   <ProjectProvider>
    <BrowserRouter>
    <Scrolltop/>
     
     {/* <ScrollManager/> */}
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-grow">
         
          <Routes>
           
            <Route path="/" element={<Single1 />} />
            <Route path="/home" element={<Single1 />} />
            
            <Route path="/about-us" element={<About />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/join-us" element={<CareersPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/services/image-video" element={<ImageVideoCollection />} />
             <Route path="/services/audio" element={<AudioCollection/>}/>
             <Route path="/services/text" element={<TextDataSourcing/>}/>
             <Route path="/services/annotation" element={<AnnotationLabeling/>}/>
             <Route path="/services/tagging" element={<AudioVideoTagging/>}/>
             <Route path= "/services/qa" element={<TextSpeechQA/>}/>
             <Route path="/services/transcription" element={<MultilingualTranscription/>}/>
             <Route path= "/services/translation" element={<TranslationLocalization/>}/>
             <Route path="/services/dubbing" element={<DubbingVoiceover/>}/>
             <Route path="/services/editing" element={<VideoEditing/>}/>
             <Route path="/services/content" element={<ContentCreation/>}/>
             <Route path="/services/animation" element={<AnimationProject/>}/>
             <Route path="/services/projects" element={<VideoProject/>}/>
             <Route path="/industries/technology" element={<IndustriesTechnologyAI/>}/>
             <Route path="/industries/ecommerce" element={<ECommerceRetail/>}/>
             <Route path="/industries/healthcare" element={<HealthcareAI/>}/>
             <Route path="/industries/automotive" element={<AutomotiveAI/>} />
             <Route path="/industries/media" element={<MediaEntertainment/>}/>
             <Route path="/services1" element={<ServicesAndIndustries/>}/>
             <Route path="/careers1" element={<CareersPage/>}/>
             <Route path="/contact2" element={<ContactPage/>}/>
             <Route path="/Admin" element={<Admin/>}/>
              <Route path="/dashboard" element={<Dashboard />} />
               <Route path="/projects" element={<ProjectList />} />
               <Route path="/Careers" element={<ProjectList/>}/>
          </Routes>
         
        </main>
        <Footer />
      </div>
     
    </BrowserRouter>
    </ProjectProvider>
    
  );
}
